module.exports = __webpack_public_path__ + "img/pro-matched.b88af357.svg";